<!-- <h1 mat-dialog-title>Hi {{data.name}}</h1> -->
<div mat-dialog-content>
	<p>Dodaj nowy rodzaj usługi</p>
	<mat-form-field appearance="fill">
		<mat-label>Nazwa</mat-label>
		<input matInput [(ngModel)]="name" />
	</mat-form-field>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="onNoClick()">Wyjdź</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="name">Dodaj</button>
</div>
